import { vec, Vector } from 'excalibur';

/**
 * Generates a random vector within a specified range.
 * If a single number is provided, both x and y will vary from -range to +range.
 * If two numbers are provided, x will vary from -xRange to +xRange and y will vary from -yRange to +yRange.
 *
 * @param range - The range for both x and y coordinates (default: 1)
 * @param yRange - Optional separate range for y coordinate
 * @returns A random Vector with x and y values within the specified ranges
 *
 * @example
 * // Both x and y vary from -10 to 10
 * const vec1 = getRandomVector(10);
 *
 * @example
 * // x varies from -5 to 5, y varies from -10 to 10
 * const vec2 = getRandomVector(5, 10);
 */
export const getRandomVector = (range: number, yRange?: number): Vector => {
  const xRange = range;
  const yRangeValue = yRange ?? range;

  const x = (Math.random() * 2 - 1) * xRange; // Random value from -xRange to xRange
  const y = (Math.random() * 2 - 1) * yRangeValue; // Random value from -yRange to yRange

  return vec(x, y);
};

